const COUNTRY_FLAG_ICONS = {
  '🇮🇳': 'circle-flags:in',
  '🇦🇺': 'circle-flags:au',
  '🇺🇸': 'circle-flags:us',
  '🇸🇦': 'circle-flags:sa',
  '🇦🇪': 'circle-flags:ae',
};

export function getCountryFlagIcon(country) {
  if (!country) return null;

  for (const [emoji, icon] of Object.entries(COUNTRY_FLAG_ICONS)) {
    if (country.includes(emoji)) return icon;
  }

  return null;
}
